import { useWeb3React } from '@web3-react/core';
import { ReactNode, useContext } from 'react';
import { SupportedChains } from '../../../config/constants';
import SpoolsState from '../../../context/spools/SpoolsState';
import themeContext from '../../../context/theme/themeContext';
import useSpoolsCreatedByUser from '../../../hooks/web3/app/useSpoolsCreatedByUser';
import Cover from '../../../layout/Cover';
import CreatorFeesClaimable from './CreatorFeesClaimable';
import CreatorFeesFallback from './CreatorFeesFallback';
import SpoolCreatorFees from './SpoolCreatorFees';

const CreatorFees: React.FC<ReactNode> = () => {
    const { theme } = useContext(themeContext);

    const { spoolsCreatedByUser } = useSpoolsCreatedByUser();

    const { chainId } = useWeb3React();

    return (
        <div className={`vault-tab creator-fees ${theme}`}>
            <Cover useMinHeight={true}>
                <div className='inner__left'>
                    <h2>Your Creator Fees</h2>
                    {spoolsCreatedByUser?.length ? (
                        <span>
                            <span className='mobile'>Tap</span>
                            <span>Click</span> a Spool to Expand
                        </span>
                    ) : null}
                </div>
                <div className='inner__right creator-fee'>
                    {spoolsCreatedByUser?.length ? (
                        <>
                            {chainId !== SupportedChains.ARBITRUM_ONE && (
                                <CreatorFeesClaimable />
                            )}
                            <SpoolsState initialSortKey='tvr'>
                                <SpoolCreatorFees />
                            </SpoolsState>
                        </>
                    ) : (
                        <CreatorFeesFallback />
                    )}

                    {/* <CreatorFeeState>
                        <CreatorFeesTable />
                    </CreatorFeeState> */}
                </div>
            </Cover>
        </div>
    );
};

export default CreatorFees;
